import React, {Component} from 'react';
import {connect} from 'react-redux';
import actions from './session.actions';
import {withRouter, Link} from 'react-router-dom';
import {uiActions} from '../chrome';
import {Avatar, CollapsibleList} from '../widgets';
import Notifications from './Notifications';
import {enableScroll, disableScroll} from '../scrollPrevention';

import './MobileUserMenu.css';

class MobileUserMenu extends Component {
	constructor(props) {
		super(props);

		this.clickOut = e => {
			if (this.props.toggleUserMenu && this.ref && !this.ref.contains(e.target)) {
				this.props.toggleUserMenu();
			}
		};

		this.goToProfile = route => {
			this.props.history.push(route);
			this.props.toggleUserMenu();
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.userMenuShown && !this.props.userMenuShown) {
			document.body.addEventListener('click', this.clickOut);
			disableScroll();
		} else if (!nextProps.userMenuShown && this.props.userMenuShown) {
			document.body.removeEventListener('click', this.clickOut);
			enableScroll();
		}
	}

	componentWillUnmount() {
		if (this.props.userMenuShown) {
			document.body.removeEventListener('click', this.clickOut);
		}
	}

	render() {
		const {userMenuShown, logout, current, toggleUserMenu} = this.props;

		const avatarImage = current && current.provider && current.provider.profile.avatarImage;

		return (
			<section
				className={`MobileUserMenu ${userMenuShown ? 'visible' : ''}`}
				ref={e => (this.ref = e)}>
				<div className="menuHeader">
					<a onClick={toggleUserMenu}>
						<span className={'icon icon-close'} />
					</a>

					{current && (
						<div className="userHeader">
							<Link
								className="accountSettings"
								to={`/account/${current.provider &&
									current.provider.profile &&
									current.provider.profile.uniqueName}`}
								onClick={this.props.toggleUserMenu}>
								Account Settings
							</Link>
							<Avatar
								extraClass="PageHeader-avatar"
								backgroundImage={avatarImage}
								size={32}
								onClick={() => {
									this.goToProfile(
										`/collections/${current.provider &&
											current.provider.profile &&
											current.provider.profile.uniqueName}`
									);
								}}
							/>
						</div>
					)}
				</div>

				{current && (
					<div className="NotificationDiv">
						<Notifications onItemClick={toggleUserMenu} />
					</div>
				)}

				<div className="bottomMenu">
					<CollapsibleList title="Support">
						<li>
							<a href="mailto:enquiries@b2me.com.au">Email us</a>
						</li>
						<li>
							<a href="tel:0432854880">Call us</a>
						</li>
						<li>
							<a href="https://b2me.zendesk.com" target="_blank" rel="noopener noreferrer">
								Support
							</a>
						</li>
						<li>
							<a href="https://b2me.zendesk.com/hc/en-us" target="_blank" rel="noopener noreferrer">
								Learning centre
							</a>
						</li>
					</CollapsibleList>
					<CollapsibleList title="Information">
						<li>
							<a
								href="https://b2me.zendesk.com/hc/en-us/categories/360000111713-About-B2Me"
								target="_blank"
								rel="noopener noreferrer">
								About us
							</a>
						</li>
						<li>
							<a
								href="https://b2me.zendesk.com/hc/en-us/articles/360003384294-Meet-our-Team"
								target="_blank"
								rel="noopener noreferrer">
								Meet our people
							</a>
						</li>
						<li>
							<Link to="/news-press" onClick={this.props.toggleUserMenu}>
								News and press
							</Link>
						</li>
						<li>
							<Link to="/events" onClick={this.props.toggleUserMenu}>
								Upcoming events
							</Link>
						</li>
						<li>
							<a href="/privacy201809_2.pdf" target="_blank" rel="noopener noreferrer">
								Privacy policy
							</a>
						</li>
						<li>
							<a href="/terms201902_1.pdf" target="_blank" rel="noopener noreferrer">
								Terms of use
							</a>
						</li>
					</CollapsibleList>
					<CollapsibleList title="B2Me For You">
						<li>
							<Link to="/schools" onClick={this.props.toggleUserMenu}>
								B2Me for schools
							</Link>
						</li>
						<li>
							<Link to="/sports" onClick={this.props.toggleUserMenu}>
								B2Me for sports
							</Link>
						</li>
						<li>
							<Link to="/real-estate" onClick={this.props.toggleUserMenu}>
								B2Me for real estate
							</Link>
						</li>
						<li>
							<Link to="/faith" onClick={this.props.toggleUserMenu}>
								B2Me for faith communities
							</Link>
						</li>
						<li>
							<a
								href="https://apps.apple.com/au/app/b2me/id1497658323?mt=8"
								target="_blank"
								rel="noopener noreferrer">
								Download B2Me from the App Store
							</a>
						</li>
						<li>
							<a
								href="https://play.google.com/store/apps/details?id=au.com.b2me"
								target="_blank"
								rel="noopener noreferrer">
								Download B2Me from the Google Play Store
							</a>
						</li>
					</CollapsibleList>
					<CollapsibleList title="Social">
						<li>
							<a href="mailto:enquiries@b2me.com.au">enquiries@b2me.com.au</a>
						</li>
						<li>
							<a href="tel:0432854880">0432854880</a>
						</li>
						<li>
							<a href="https://medium.com/b2me-australia" target="_blank" rel="noopener noreferrer">
								<span>Blog</span>
							</a>
						</li>
						<li>
							<a
								href="https://www.facebook.com/B2MeAustralia/"
								target="_blank"
								rel="noopener noreferrer">
								<span>Facebook</span>
							</a>
						</li>
						<li>
							<a href="https://twitter.com/B2MeAustralia" target="_blank" rel="noopener noreferrer">
								<span>Twitter</span>
							</a>
						</li>
						<li>
							<a
								href="https://www.instagram.com/b2meaustralia/"
								target="_blank"
								rel="noopener noreferrer">
								<span>Instagram</span>
							</a>
						</li>
						<li>
							<a
								href="https://www.pinterest.com.au/b2meaustralia/boards/"
								target="_blank"
								rel="noopener noreferrer">
								<span>Pinterest</span>
							</a>
						</li>
					</CollapsibleList>

					{current && (
						<a
							onClick={() => {
								toggleUserMenu();
								logout();
							}}>
							<span>Logout</span>
						</a>
					)}

					<p>Copyright B2Me {new Date().getFullYear()}.</p>
				</div>
			</section>
		);
	}
}

export default withRouter(
	connect(
		state => ({
			screenSize: state.ui.screenSize,
			userMenuShown: state.ui.userMenuShown,
			current: state.session && state.session.status === 'authenticated' && state.session.current
		}),
		dispatch => ({
			logout: () => dispatch(actions.logout()),
			toggleUserMenu: () => dispatch(uiActions.uiToggleUserMenu())
		})
	)(MobileUserMenu)
);



// WEBPACK FOOTER //
// ./src/user/MobileUserMenu.js